import React from 'react'
import { SchoolCard as LightLectureViewerSchoolCard } from '@systemeio/light-lecture-viewer'
import useUser, { isAuthorizedUser } from 'shared/hooks/use-user'
import { limitObj_12_24_48 } from 'shared/route-query/constants/pagination-limit-array'
import { usePagination } from 'shared/route-query/hooks/use-pagination'
import EmptyList from 'modules/profile/manage-suscriptions/components/table/empty-list'
import TableLimitPagination from 'modules/profile/manage-suscriptions/components/table/table-limit-pagination'
import { useExploreCourses } from '../hooks/use-explore-courses'
import { getCourseCardLinkTarget } from '../utils/get-course-card-link-target'
import { SchoolCardsSkeleton } from './school-card/school-cards-skeleton'

export const ExploreCoursesTab = () => {
  const { user } = useUser()
  const { limit, setLimit, pagination, setPagination } = usePagination({
    isStaticUrl: true,
    initLimit: limitObj_12_24_48.short,
  })
  const { exploreCourses } = useExploreCourses({ limit, pagination })

  return (
    <div>
      <div
        className={
          'mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3 lg:gap-6 xl:grid-cols-4'
        }
      >
        {exploreCourses ? (
          exploreCourses.items.length ? (
            exploreCourses.items.map(courseItem => (
              <LightLectureViewerSchoolCard
                key={courseItem.id}
                courseCover={courseItem.image?.path || null}
                description={courseItem.description}
                href={courseItem.courseUrl}
                target={getCourseCardLinkTarget(courseItem.courseUrl)}
                variant="white"
                title={courseItem.name}
                instructorName={courseItem.instructorName}
                totalLecturesCount={courseItem.totalLecturesCount}
                accessFrom={null}
                progress={undefined}
                userTimeFormat={
                  isAuthorizedUser(user)
                    ? {
                        dateFormat: user.dateFormat,
                        timeFormat: user.timeFormat,
                        timezone: user.timezone,
                      }
                    : null
                }
              />
            ))
          ) : (
            <EmptyList className="col-span-full" />
          )
        ) : (
          <SchoolCardsSkeleton />
        )}
      </div>
      <div className="mt-4 flex justify-end gap-6 md:mt-5 lg:mt-6">
        <TableLimitPagination
          data={exploreCourses}
          limiter={{ limit, setLimit }}
          paginator={{
            pagination,
            setPagination,
            hasMore: exploreCourses?.hasMore,
          }}
          limitObj={limitObj_12_24_48}
        />
      </div>
    </div>
  )
}
